import { useTheme, THEME_DOMAIN, COOKIE_THEME_KEY } from '@donaswap/hooks'

export { THEME_DOMAIN, COOKIE_THEME_KEY }

export default useTheme
